import { Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";

type ButtonVariant = "primary" | "secondary" | "ghost" | "simple" | "danger";

@Component({
  selector: "app-button",
  standalone: true,
  imports: [NgClass],
  templateUrl: "./ButtonComponent.html",
  styleUrl: "./ButtonComponent.scss",
})
export class AppButtonComponent {
  @Input() variant: ButtonVariant = "primary";
  @Input() type: "button" | "submit" = "button";
  @Input() disabled = false;
  @Input() form?: string;

  get variantClass(): string {
    return `app-btn--${this.variant}`;
  }
}
